import { Component, Input, OnInit } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { DataService } from 'src/app/services/data.service';
import { Drink } from 'src/interfaces/drink.model';
import { MatDialog } from '@angular/material/dialog';
import { MenuDrinkDialogComponent } from '../menu-drink-dialog/menu-drink-dialog.component';
import { sheetDialogConfig } from 'src/app/directives/sheet.directive';
import { BasketService } from 'src/app/services/basket.service';
import { Modificators } from 'src/interfaces/modificators.model';
import { LocalizationService } from 'src/app/services/localization.service';
import { ImageCacheService } from 'src/app/services/image-cache.service';
import { Locale } from 'src/interfaces/locale.model';
import { NO_PHOTO } from 'src/app/utils/no-photo';

@Component({
    selector: 'app-basket-drink-card',
    templateUrl: './menu-basket-drink-card.component.html',
    styleUrls: ['./menu-basket-drink-card.component.css'],
    standalone: false
})
export class MenuBasketDrinkCardComponent implements OnInit {

  constructor(
    private dataService: DataService,
    private basketService: BasketService,
    private localization: LocalizationService,
    private imageCache: ImageCacheService,
    private dialog: MatDialog
  ) {
    this.locale = this.dataService.locale;
  }

  locale: Locale | null = null;

  @Input() drink: Drink | null = null;
  @Input() isLast: boolean = false;

  // Вариант
  variant: string | null = null;
  // Модификаторы
  modificators: Modificators | undefined = undefined;

  // Изображение заглушка
  imageSrc: string = NO_PHOTO.drink;

  ngOnInit(): void {
    if (this.drink) {
      // Цена напитка
      if (this.drink.variability && this.drink.variants.length > this.drink.choise) {
        console.log('MenuBasketDrinkCard | ngOnInit() | choise:', this.drink.choise, ' | count:', this.drink.count, ' | price:', this.drink.totalPrice);
        
        // Вариант напитка
        this.variant = this.drink.variants[this.drink.choise].title;
      }

      // Image
      if (this.drink?.image?.trim()) {
        this.imageCache.getImage(this.drink.image, NO_PHOTO.drink).then(src => {
          this.imageSrc = src;
        });
      }

      this.modificators = typeof this.drink.modificators === 'object' ? this.drink.modificators : undefined;
      this.modificators = this.modificators?.items?.length ? this.modificators : undefined;
      this.modificators = this.modificators?.items.some((modificator) => modificator.count > 0) ? this.modificators : undefined;
    }
  }

  increment(): void {
    if (!this.drink) return;
    this.drink.count++;
    this.basketService.updateDrinkInBasket(this.drink);
  }

  decrement(): void {
    if (!this.drink) return;
    if (this.drink.count > 1) {
      this.drink.count--;
      this.basketService.updateDrinkInBasket(this.drink);
    } else {
      this.basketService.removeDrinkFromBasket(this.drink);
    }
  }

  onDrinkClicked(): void {
    this.dialog.open(MenuDrinkDialogComponent, sheetDialogConfig(cloneDeep(this.drink)));
  }

  get localSize(): string {
    return this.drink?.size ? this.drink.size.toLocaleString('ru-RU', { useGrouping: true }) : '';
  }
}
